import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useAuth } from "./auth";

function AdminRoute({ component: Component, ...rest }) {
  const { authTokens } = useAuth();

  return (
    <Route
      {...rest}
      render={props =>
        authTokens.accessCode >= 2 ? (
          <Component {...props} />
        ) : (
            <Redirect to="/home" />
        )
      }
    />
  );
}

export default AdminRoute;